module.exports = __webpack_public_path__ + "img/polipay.162e0b62.svg";